import { ProductCatalog } from "../../components/site/ProductCatalog";
import { PageHeader } from "../../components/site/Bits";

export default function Store() {
  return (
    <div className="space-y-10">
      <PageHeader eyebrow="Buy products" title="Digital products store" text="Browse and purchase digital products from Raphanex. Purchases unlock instantly in My Purchases." />
      <ProductCatalog base="/store" inApp />
    </div>
  );
}
